define("shared/components/shared/social/facebook-modal/facebook-page", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <li
    class={{concat-classes
      "tAC--authCard"
      (if (eq @selectedPage.id @page.id) "tAC--authCard--selected")
      (if @isRunning "u--mute")
    }}
  >
    <label class="tAC--authCard__label" for={{concat "page-" @page.id}}>
      <div class="o--user">
        <span class="o--user__avatarProfile">
          <img
            alt={{or @page.name_with_location_descriptor @page.name}}
            class="o--user__avatar"
            src={{or @page.picture.data.url "/assets/images/img--userAvatar--placeholder.svg"}}
          />
        </span>
        <span class="o--user__avatarChild--facebook"><i class="i--facebook--w"></i></span>
        <span class="o--user__title">
          <span class="u--ellipsis">{{or @page.name_with_location_descriptor @page.name}}</span>
        </span>
        <span class="o--user__desc">{{t "credentials.facebook_page"}}</span>
      </div>
      <Input
        @type="radio"
        class="tAC--authCard__radio"
        id={{concat "page-" @page.id}}
        name="facebookPage"
        {{on "input" (fn @selectPage @page)}}
      />
    </label>
  </li>
  */
  {
    "id": "a1atSSN/",
    "block": "[[[10,\"li\"],[15,0,[28,[37,0],[\"tAC--authCard\",[52,[28,[37,2],[[30,1,[\"id\"]],[30,2,[\"id\"]]],null],\"tAC--authCard--selected\"],[52,[30,3],\"u--mute\"]],null]],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"tAC--authCard__label\"],[15,\"for\",[28,[37,3],[\"page-\",[30,2,[\"id\"]]],null]],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n        \"],[10,\"img\"],[15,\"alt\",[28,[37,4],[[30,2,[\"name_with_location_descriptor\"]],[30,2,[\"name\"]]],null]],[14,0,\"o--user__avatar\"],[15,\"src\",[28,[37,4],[[30,2,[\"picture\",\"data\",\"url\"]],\"/assets/images/img--userAvatar--placeholder.svg\"],null]],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__avatarChild--facebook\"],[12],[10,\"i\"],[14,0,\"i--facebook--w\"],[12],[13],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__title\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--ellipsis\"],[12],[1,[28,[35,4],[[30,2,[\"name_with_location_descriptor\"]],[30,2,[\"name\"]]],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__desc\"],[12],[1,[28,[35,5],[\"credentials.facebook_page\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,6],[[24,0,\"tAC--authCard__radio\"],[16,1,[28,[37,3],[\"page-\",[30,2,[\"id\"]]],null]],[24,3,\"facebookPage\"],[4,[38,7],[\"input\",[28,[37,8],[[30,4],[30,2]],null]],null]],[[\"@type\"],[\"radio\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@selectedPage\",\"@page\",\"@isRunning\",\"@selectPage\"],false,[\"concat-classes\",\"if\",\"eq\",\"concat\",\"or\",\"t\",\"input\",\"on\",\"fn\"]]",
    "moduleName": "shared/components/shared/social/facebook-modal/facebook-page.hbs",
    "isStrictMode": false
  });
  class FacebookPageComponent extends _component2.default {}
  _exports.default = FacebookPageComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FacebookPageComponent);
});